import { toast } from "react-hot-toast";
import { useDeleteAccountMutation } from "queries";
import { Popup } from "components/UI/Popup";
import { BaseButton } from "components/buttons/BaseButton";
import "./style/DeleteAccount.scss";

interface IDeleteAccountProps {
  isOpen: boolean;
  togglePopup: () => void;
}

export const DeleteAccount:React.FC<IDeleteAccountProps> = (props) => {
  const { isOpen, togglePopup } = props;
  const deleteAccountMutation = useDeleteAccountMutation();

  const handleDelete = async (): Promise<void> => {
    try {
      await deleteAccountMutation.mutateAsync();
      toast.success(
        "Please check your mailbox to continue.",
        { duration: 5000 }
      );
    } catch {
      toast.error(
        "Error deleting account, please try again in a few hours",
        { duration: 5000 }
      );
    } finally {
      togglePopup();
    }
  };

  return (
    <Popup
      isOpen={isOpen}
      popupClass="DeleteAccount"
    >
      <p className="DeleteAccount-Description">
        {/* eslint-disable-next-line max-len */}
        By completing this process your account will be permanently deleted in the next 30 days. To proceed with removal, click "Confirm" and follow the instructions sent via email.
      </p>
      <BaseButton onClick={handleDelete}>Confirm</BaseButton>
      <button onClick={togglePopup} className="DeleteAccount-CancelBtn">No Thanks, I'll Stay</button>
    </Popup>
  );
};
